(function () {
  function updateB2BAlert(input) {
    const section = input.closest('[data-wig-product-section]');
    if (!section) return;

    const alert = section.querySelector('[data-b2b-alert]');
    if (!alert) return;

    const threshold = parseInt(alert.dataset.threshold || '10', 10);
    const value = parseInt(input.value || '0', 10);
    alert.hidden = !(Number.isFinite(value) && value >= threshold);
  }

  function bindMediaGallery(section) {
    const mainImage = section.querySelector('[data-wig-product-main-image]');
    const imageFrame = section.querySelector('[data-wig-product-frame]');
    const openButton = section.querySelector('[data-wig-product-open-media]');
    const lightbox = section.querySelector('[data-wig-product-lightbox]');
    const lightboxDialog = section.querySelector('[data-wig-product-lightbox-dialog]');
    const lightboxImage = section.querySelector('[data-wig-product-lightbox-image]');
    const closeButtons = Array.from(section.querySelectorAll('[data-wig-product-lightbox-close]'));
    const previousButtons = Array.from(section.querySelectorAll('[data-wig-product-prev]'));
    const nextButtons = Array.from(section.querySelectorAll('[data-wig-product-next]'));
    const thumbs = Array.from(section.querySelectorAll('[data-wig-product-thumb]'));

    if (!mainImage) return;

    const preloadedImages = new Set();
    let currentIndex = 0;
    let lastFocusedElement = null;
    let ignoreNextOpenClick = false;

    const mediaItems = thumbs.length
      ? thumbs.map((thumb) => ({
          thumb,
          mediaId: thumb.dataset.mediaId || '',
          src: thumb.dataset.imageSrc || '',
          largeSrc: thumb.dataset.imageLargeSrc || thumb.dataset.imageSrc || '',
          srcset: thumb.dataset.imageSrcset || '',
          sizes: thumb.dataset.imageSizes || '',
          alt: thumb.dataset.imageAlt || '',
        }))
      : [
          {
            thumb: null,
            mediaId: mainImage.dataset.mediaId || '',
            src: mainImage.dataset.imageSrc || mainImage.currentSrc || mainImage.src,
            largeSrc: mainImage.dataset.imageLargeSrc || mainImage.currentSrc || mainImage.src,
            srcset: mainImage.dataset.imageSrcset || mainImage.getAttribute('srcset') || '',
            sizes: mainImage.dataset.imageSizes || mainImage.getAttribute('sizes') || '',
            alt: mainImage.alt || '',
          },
        ];

    if (mediaItems.length === 0) return;

    const activeThumbIndex = mediaItems.findIndex((item) => item.thumb && item.thumb.classList.contains('is-active'));
    const mainMediaIndex = mediaItems.findIndex((item) => item.mediaId && item.mediaId === mainImage.dataset.mediaId);
    currentIndex = activeThumbIndex >= 0 ? activeThumbIndex : Math.max(mainMediaIndex, 0);

    function normalizeIndex(index) {
      return (index + mediaItems.length) % mediaItems.length;
    }

    function setImageSource(image, item, useLargeImage) {
      const nextSrc = useLargeImage ? item.largeSrc || item.src : item.src;

      if (!nextSrc) return;

      if (useLargeImage) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
      } else {
        if (item.srcset) {
          image.srcset = item.srcset;
        } else {
          image.removeAttribute('srcset');
        }

        if (item.sizes) {
          image.sizes = item.sizes;
        } else {
          image.removeAttribute('sizes');
        }
      }

      image.src = nextSrc;
      image.alt = item.alt || '';
      image.dataset.mediaId = item.mediaId;
      image.dataset.imageSrc = item.src;
      image.dataset.imageLargeSrc = item.largeSrc;
      image.dataset.imageSrcset = item.srcset;
      image.dataset.imageSizes = item.sizes;
    }

    function preloadImage(src, srcset, sizes) {
      const preloadKey = srcset || src;

      if (!preloadKey || preloadedImages.has(preloadKey)) return;

      preloadedImages.add(preloadKey);

      const image = new Image();
      image.decoding = 'async';

      if (srcset) {
        image.srcset = srcset;
      }

      if (sizes) {
        image.sizes = sizes;
      }

      image.src = src;
    }

    function preloadMedia(index) {
      const item = mediaItems[normalizeIndex(index)];

      preloadImage(item.src, item.srcset, item.sizes);
      preloadImage(item.largeSrc);
    }

    function preloadNearbyMedia() {
      preloadMedia(currentIndex);

      if (mediaItems.length > 1) {
        preloadMedia(currentIndex + 1);
        preloadMedia(currentIndex - 1);
      }
    }

    function updateThumbs() {
      mediaItems.forEach((item, index) => {
        if (!item.thumb) return;

        const isActive = index === currentIndex;
        item.thumb.classList.toggle('is-active', isActive);
        item.thumb.setAttribute('aria-current', isActive ? 'true' : 'false');

        if (isActive && typeof item.thumb.scrollIntoView === 'function') {
          item.thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
    }

    function updateLightbox() {
      if (!lightbox || !lightboxImage) return;

      setImageSource(lightboxImage, mediaItems[currentIndex], true);
    }

    function activateMedia(index) {
      currentIndex = normalizeIndex(index);

      setImageSource(mainImage, mediaItems[currentIndex], false);
      updateThumbs();
      updateLightbox();
      preloadNearbyMedia();
    }

    function showPreviousMedia(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      activateMedia(currentIndex - 1);
    }

    function showNextMedia(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      activateMedia(currentIndex + 1);
    }

    function closeLightbox() {
      if (!lightbox || lightbox.hidden) return;

      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('wig-product-lightbox-open');
      document.removeEventListener('keydown', handleLightboxKeydown);

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    function handleLightboxKeydown(event) {
      if (!lightbox || lightbox.hidden) return;

      if (event.key === 'Escape') {
        closeLightbox();
      }

      if (event.key === 'ArrowLeft') {
        showPreviousMedia(event);
      }

      if (event.key === 'ArrowRight') {
        showNextMedia(event);
      }
    }

    function openLightbox() {
      if (!lightbox || !lightboxImage) return;

      lastFocusedElement = document.activeElement;
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      updateLightbox();
      document.documentElement.classList.add('wig-product-lightbox-open');
      document.addEventListener('keydown', handleLightboxKeydown);

      const closeButton = lightbox.querySelector('.wig-product-lightbox__close');
      if (closeButton && typeof closeButton.focus === 'function') {
        closeButton.focus();
      }
    }

    function bindSwipe(target, onPrevious, onNext) {
      let startX = 0;
      let startY = 0;

      if (!target) return;

      target.addEventListener(
        'touchstart',
        (event) => {
          if (event.touches.length !== 1) return;

          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        },
        { passive: true }
      );

      target.addEventListener(
        'touchend',
        (event) => {
          if (!startX || !event.changedTouches.length) return;

          const deltaX = event.changedTouches[0].clientX - startX;
          const deltaY = event.changedTouches[0].clientY - startY;
          const isHorizontalSwipe = Math.abs(deltaX) > 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25;

          startX = 0;
          startY = 0;

          if (!isHorizontalSwipe) return;

          if (deltaX > 0) {
            onPrevious();
          } else {
            onNext();
          }
        },
        { passive: true }
      );
    }

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        activateMedia(index);
      });
    });

    previousButtons.forEach((button) => button.addEventListener('click', showPreviousMedia));
    nextButtons.forEach((button) => button.addEventListener('click', showNextMedia));
    closeButtons.forEach((button) => button.addEventListener('click', closeLightbox));

    if (openButton) {
      openButton.addEventListener('click', () => {
        if (ignoreNextOpenClick) {
          ignoreNextOpenClick = false;
          return;
        }

        openLightbox();
      });
    }

    bindSwipe(openButton || imageFrame, () => {
      ignoreNextOpenClick = true;
      showPreviousMedia();
    }, () => {
      ignoreNextOpenClick = true;
      showNextMedia();
    });

    bindSwipe(lightboxDialog, showPreviousMedia, showNextMedia);

    preloadNearbyMedia();

    const preloadAllMedia = () => mediaItems.forEach((_, index) => preloadMedia(index));

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(preloadAllMedia, { timeout: 1400 });
    } else {
      window.setTimeout(preloadAllMedia, 700);
    }
  }

  function bindSection(section) {
    if (section.dataset.wigProductBound === 'true') return;
    section.dataset.wigProductBound = 'true';

    bindMediaGallery(section);

    section.querySelectorAll('[data-b2b-quantity]').forEach((input) => {
      updateB2BAlert(input);
      input.addEventListener('input', () => updateB2BAlert(input));
      input.addEventListener('change', () => updateB2BAlert(input));
    });
  }

  function init() {
    document.querySelectorAll('[data-wig-product-section]').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-wig-product-section]');
    if (section) bindSection(section);
  });
})();
